import React from "react";
import Icon from '../Icon';

export default class Facebook extends React.PureComponent {
    render() {
        return (
            <Icon className={'facebook'} img={require('../../../../assets/images/icons/social/facebook.png')}/>
        );
    }
}
